import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EventRule } from '@/features/event-rules/schemas/event-rules.schema.ts';

export const usePatchEventRulesMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (eventRules: Pick<EventRule, 'eventRuleId' | 'status'>[]) => {
      return toast.promise(client.patch(`/events/rules`, eventRules), {
        loading: 'Updating event rules...',
        success: 'Successfully updated the event rules.',
        error: (_: unknown) => `Uh oh, there was an error with updating the event rules.`,
      });
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['event-rules'] });
    },
  });
};
